
import React from 'react';
import { Heart, Mail, Phone, MapPin, Globe } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-purple-700 rounded-xl flex items-center justify-center shadow-md">
                <span className="text-white font-bold text-xl tracking-tight">DD</span>
              </div>
              <div>
                <h3 className="text-xl font-bold tracking-tight">Decide Digital</h3>
                <p className="text-gray-400 text-sm font-medium">Agência Digital Especializada</p>
              </div>
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Especializada em soluções digitais inovadoras para produtos, comércio e SaaS. 
              Transformamos ideias em realidade digital com qualidade e excelência.
            </p>
            
            {/* Nova assinatura */}
            <div className="bg-gray-800 rounded-lg p-4 border-l-4 border-blue-500">
              <div className="flex items-center text-gray-300 text-sm mb-2">
                <Heart className="w-4 h-4 mr-2 text-red-500" />
                <span className="font-medium">Desenvolvido com amor em Cacoal, RO</span>
              </div>
              <div className="flex items-center text-gray-400 text-xs">
                <Globe className="w-3 h-3 mr-1" />
                <span>Atendemos todo o Brasil | Soluções Digitais de Alto Padrão</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-blue-400">Nossos Serviços</h4>
            <ul className="space-y-2 text-gray-300">
              <li className="hover:text-white transition-colors cursor-pointer">• Desenvolvimento Web</li>
              <li className="hover:text-white transition-colors cursor-pointer">• E-commerce Profissional</li>
              <li className="hover:text-white transition-colors cursor-pointer">• Aplicativos Mobile</li>
              <li className="hover:text-white transition-colors cursor-pointer">• Marketing Digital</li>
              <li className="hover:text-white transition-colors cursor-pointer">• Consultoria Tech</li>
              <li className="hover:text-white transition-colors cursor-pointer">• Linktrees Profissionais</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-blue-400">Fale Conosco</h4>
            <div className="space-y-3 text-gray-300">
              <div className="flex items-center hover:text-white transition-colors">
                <Phone className="w-4 h-4 mr-3 text-green-400" />
                <span className="text-sm font-medium">(69) 99208-3972</span>
              </div>
              <div className="flex items-center hover:text-white transition-colors">
                <Mail className="w-4 h-4 mr-3 text-blue-400" />
                <span className="text-sm font-medium">contato@decidedigital.com.br</span>
              </div>
              <div className="flex items-center hover:text-white transition-colors">
                <MapPin className="w-4 h-4 mr-3 text-red-400" />
                <span className="text-sm font-medium">Cacoal, Rondônia</span>
              </div>
              <div className="flex items-center hover:text-white transition-colors">
                <Globe className="w-4 h-4 mr-3 text-purple-400" />
                <span className="text-sm font-medium">decidedigital.com.br</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-center md:text-left">
              <p className="text-gray-400 text-sm mb-1">
                © 2024 <span className="text-white font-semibold">Decide Digital</span>. Todos os direitos reservados.
              </p>
              <p className="text-gray-500 text-xs">
                CNPJ: 40.445.772/0001-51 | Agência Digital Especializada
              </p>
            </div>
            <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-6">
              <a href="#" className="text-gray-400 hover:text-blue-400 text-sm transition-colors font-medium">
                Política de Privacidade
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 text-sm transition-colors font-medium">
                Termos de Uso
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 text-sm transition-colors font-medium">
                Portfólio
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
